import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// attach bearer token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ambrai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const inr = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN");

// Optimise Pexels imagery (compress + resize) for fast loading
export const px = (url, w = 900) => {
  if (!url) return undefined;
  if (url.includes("images.pexels.com") && !url.includes("?")) {
    return `${url}?auto=compress&cs=tinysrgb&w=${w}`;
  }
  return url;
};

export default api;
